import { render, staticRenderFns } from "./IndexPanel.vue?vue&type=template&id=5594edd4&"
import script from "./IndexPanel.vue?vue&type=script&lang=js&"
export * from "./IndexPanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports